import React from "react";
import "./ImageComponent.css";

const image = (props) => {
  return (
    <div className="personCard">
      <a href={props.link} target="__blank">
        <img className="personImage" src={props.path} alt={props.title} />
      </a>
    </div>
  );
};

export default image;
